/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import React from 'react';

import PropTypes from 'prop-types';
import ClientRelocationPolicyTable from './policies/dataTables/clientRelocationPolicyTable.component';
import { useState, useEffect } from 'react';
import ReloPolicyDetails from './policies/reloPolicyDetails.component';
import BillingPolicyTable from './policies/dataTables/billingPolicyTable.component';
import BillingPolicyDetails from './policies/billingPolicyDetails.component';
import { Dialog } from '@mui/material';

const ClientPoliciesTab = ({ clientDetails, enumerations, staticBenefits, prebuiltTriggers, expenseCodes }) => {

  const [reloPolicyInfo, setReloPolicyInfo] = useState(null);
  const [billingPolicyInfo, setBillingPolicyInfo] = useState(null);
  const [isPolicyFullScreen, setIsPolicyFullScreen] = useState(false);
  
  let feeExpenseCodes = expenseCodes && expenseCodes.length > 0 ? expenseCodes.filter((ec) => ec.reportCategory === 'SERVICE FEE') : [];

  // Sync reloPolicyInfo with Redux store when clientRelocationPolicies updates
  useEffect(() => {
    if (reloPolicyInfo && clientDetails?.clientRelocationPolicies) {
      const updatedPolicy = clientDetails.clientRelocationPolicies.find(
        (crp) => crp.policy.relocationPolicyId === reloPolicyInfo.policy.relocationPolicyId
      );
      if (updatedPolicy) {
        setReloPolicyInfo(updatedPolicy);
      }
    }
  }, [clientDetails?.clientRelocationPolicies]);

  useEffect(() => {
    if (!billingPolicyInfo || !clientDetails?.clientBillingPolicies) return;

    const updatedPolicy = clientDetails.clientBillingPolicies.find(
      policy => String(policy.billingPolicy.billingPolicyId) === String(billingPolicyInfo.billingPolicy.billingPolicyId)
    );
    if (updatedPolicy) setBillingPolicyInfo(updatedPolicy);
    else setBillingPolicyInfo(null);
  }, [clientDetails?.clientBillingPolicies]);

  return (
    <Box sx={{ padding: '20px' }}>
      {clientDetails && (
        <>
          <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
            <Grid item md={(reloPolicyInfo || billingPolicyInfo) ? 6 : 12}>
              <ClientRelocationPolicyTable 
                billingPolicies={clientDetails.clientBillingPolicies} 
                clientReloPolicies={clientDetails.clientRelocationPolicies} 
                clientRecordId={clientDetails.clientDetails.clientRecordId} 
                clientDivisions={clientDetails.clientDivisions} 
                enumerations={enumerations.allEnums} 
                billingPolicySelected={billingPolicyInfo ? true : false}
                newReloPolicySelected={(id) => {
                  setBillingPolicyInfo(null);
                  setReloPolicyInfo(clientDetails.clientRelocationPolicies.find((crp) => crp.policy.relocationPolicyId === id));
                }}
              />
              <Box sx={{paddingTop: '16px'}}>
                <BillingPolicyTable
                  billingPolicies={clientDetails.clientBillingPolicies} 
                  clientReloPolicies={clientDetails.clientRelocationPolicies} 
                  clientRecordId={clientDetails.clientDetails.clientRecordId} 
                  clientDivisions={clientDetails.clientDivisions} 
                  enumerations={enumerations.allEnums} 
                  reloPolicySelected={reloPolicyInfo ? true : false}
                  newBillingPolicySelected={(id) => {
                    setReloPolicyInfo(null);
                    setBillingPolicyInfo(clientDetails.clientBillingPolicies.find((crp) => crp.billingPolicy.billingPolicyId === id));
                  }}
                />
              </Box>
            </Grid>
            {reloPolicyInfo && staticBenefits && (
              <Grid item md={6}>
                
                <Box>
                  <ReloPolicyDetails policyDetails={reloPolicyInfo} clientBillingPolicies={clientDetails.clientBillingPolicies} policyWasDeleted={() => setReloPolicyInfo(null)} isHalfScreen={true} setIsPolicyFullScreen={setIsPolicyFullScreen} />
                </Box>
              </Grid>
            )}
            {billingPolicyInfo && (
              <Grid item md={6}>
                <Box>
                  <BillingPolicyDetails policyDetails={billingPolicyInfo} prebuiltTriggers={prebuiltTriggers} expenseCodes={feeExpenseCodes} clientFeeTriggerFields={clientDetails.clientFeeTriggerFields} policyWasDeleted={() => setBillingPolicyInfo(null)} />
                </Box>
              </Grid>
            )}
          </Grid>
          {reloPolicyInfo && staticBenefits && isPolicyFullScreen && (
            <Dialog open={isPolicyFullScreen} fullWidth={true} maxWidth={'xl'} onClose={() => setIsPolicyFullScreen(false)}>
              <Box>
                <ReloPolicyDetails policyDetails={reloPolicyInfo} clientBillingPolicies={clientDetails.clientBillingPolicies} policyWasDeleted={() => setReloPolicyInfo(null)} isHalfScreen={false} setIsPolicyFullScreen={setIsPolicyFullScreen} />
              </Box>
            </Dialog>
          )}
        </>
      )}
    </Box>
  );  
};

ClientPoliciesTab.propTypes = {
  formikProps: PropTypes.object.isRequired,
  clientDetails: PropTypes.object.isRequired
};


const mapStateToProps = state => {
  const { clientDetails } = state.clients.clientsInfo[state.clients.currentClientId];
  const { staticBenefits } = state.clients;
  return {
    clientDetails,
    staticBenefits
  };
};
  
export default compose(
  connect(mapStateToProps),
)(ClientPoliciesTab);